import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import type {
  ImportApiResponse,
  ImportConfirmRequest,
  ImportCsvRequest,
  ImportGoogleSheetsRequest,
  ImportValidationReport,
} from '@cdw-ae/common-data';
import { API_URL_BUILDER, ApiUrlBuilder } from '@cdw-ae/routes-shared-api';
import type { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class ImportService {
  constructor(
    private readonly http: HttpClient,
    @Inject(API_URL_BUILDER) private readonly urlBuilder: ApiUrlBuilder
  ) {}

  initiateImportCsv(request: ImportCsvRequest): Observable<ImportApiResponse> {
    return this.http.post<ImportApiResponse>(
      this.urlBuilder.backendApi('imports', 'csv/validate'),
      request
    );
  }

  initiateImportGoogleSheets(request: ImportGoogleSheetsRequest): Observable<ImportApiResponse> {
    return this.http.post<ImportApiResponse>(
      this.urlBuilder.backendApi('imports', 'google-sheets/validate'),
      request
    );
  }

  executeImport(request: ImportConfirmRequest): Observable<ImportApiResponse> {
    return this.http.post<ImportApiResponse>(
      this.urlBuilder.backendApi('imports', 'execute'),
      request
    );
  }

  cancelImport(jobId: number): Observable<{ success: boolean }> {
    return this.http.post<{ success: boolean }>(
      this.urlBuilder.backendApi('imports', `${jobId}/cancel`),
      {}
    );
  }

  getValidationReport(jobId: number): Observable<ImportValidationReport> {
    return this.http.get<ImportValidationReport>(
      this.urlBuilder.backendApi('imports', `${jobId}/validation-report`)
    );
  }

  getSheetTabs(sheetId: string): Observable<{ tabs: string[] }> {
    return this.http.get<{ tabs: string[] }>(
      this.urlBuilder.backendApi('imports', `sheets/${sheetId}/tabs`)
    );
  }
}
